export default "__VITE_ASSET__CxFaKHlN__"